import type { PokerSuit } from './PokerSuit';

export const pokerSuitsByIndex: PokerSuit[] = ['c', 'd', 'h', 's'];
